module.exports = __webpack_public_path__ + "img/ee.54d30683.svg";